import { render, staticRenderFns } from "./VaTimelineSeparator.demo.vue?vue&type=template&id=5fd2a1cb&"
import script from "./VaTimelineSeparator.demo.vue?vue&type=script&lang=js&"
export * from "./VaTimelineSeparator.demo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports